import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 pt-32">
      <div className="max-w-lg text-center" data-testid="payment-cancel">
        <XCircle className="w-14 h-14 text-terracotta mx-auto mb-6" />
        <h1 className="font-serif text-5xl text-forest mb-4">No worries.</h1>
        <p className="text-forest-soft text-lg mb-8">
          Your checkout was cancelled and your basket is still waiting for you.
        </p>
        <Link to="/shop" data-testid="cancel-continue" className="inline-block rounded-full bg-forest hover:bg-terracotta text-cream px-8 py-3.5 text-sm uppercase tracking-widest font-semibold" style={{ transition: "background-color 0.3s ease" }}>
          Return to shop
        </Link>
      </div>
    </div>
  );
}
